export class MxLanguage {
	public readonly id: string;
	public readonly title: string;
	public readonly code: string;
	public readonly lcid: number;
	public readonly parentLcid: number;
	public readonly parentTitle: string;
	public readonly flagUrl: string;
	public readonly twoLetterCode: string;
	public readonly isRightToLeft: boolean;
	public readonly isBaseLanguageInGroup: boolean;
	public readonly isDefaultUiLanguage: boolean;
	public readonly isMailLanguage: boolean;

	constructor(opt: Omit<MxLanguage, 'toJSON'>) {
		this.id = opt.id;
		this.title = opt.title;
		this.code = opt.code;
		this.lcid = opt.lcid;
		this.parentLcid = opt.parentLcid;
		this.parentTitle = opt.parentTitle;
		this.flagUrl = opt.flagUrl;
		this.twoLetterCode = opt.twoLetterCode;
		this.isRightToLeft = opt.isRightToLeft;
		this.isBaseLanguageInGroup = opt.isBaseLanguageInGroup;
		this.isDefaultUiLanguage = opt.isDefaultUiLanguage;
		this.isMailLanguage = opt.isMailLanguage;
	}

	public toJSON() {
		return JSON.stringify({
			id: this.id,
			title: this.title,
			code: this.code,
			lcid: this.lcid,
			parentLcid: this.parentLcid,
			parentTitle: this.parentTitle,
			flagUrl: this.flagUrl,
			twoLetterCode: this.twoLetterCode,
			isRightToLeft: this.isRightToLeft,
			isBaseLanguageInGroup: this.isBaseLanguageInGroup,
			isDefaultUiLanguage: this.isDefaultUiLanguage,
			isMailLanguage: this.isMailLanguage,
		});
	}
}
